"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'PreviewBox',
  props: {
    productId: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      info: {},
      sliderImages: [],
      loading: true
    };
  },
  watch: {
    productId: {
      immediate: true,
      handler: function handler(v) {
        if (v) this.getInfo(v);
      }
    }
  },
  methods: {
    // 后台商品详情，无需登录即可预览
    getInfo: function getInfo(id) {
      var _this = this;
      this.loading = true;
      (0, _product.productDetailApi)(id).then(function (res) {
        _this.info = res;
        _this.info.image = _this.$selfUtil.setDomain(res.image);
        _this.info.content = res.content ? _this.$selfUtil.replaceImgSrcHttps(res.content) : '';
        var imgs = [];
        try {
          imgs = JSON.parse(res.sliderImage);
        } catch (e) {
          imgs = [];
        }
        _this.sliderImages = imgs.map(function (img) {
          return _this.$selfUtil.setDomain(img);
        });
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
};